import React, { useContext, useEffect, useRef } from 'react'
import DocumentsContext from 'app/react/components/documents/DocumentsContext'
import Sidebar from 'app/react/components/documents/Sidebar'
import Table from 'app/react/components/documents/Table'
import Pagination from 'app/react/components/Pagination'
import classNames from 'classnames'

export default function DocumentsContent () {

  const { categories, headerTitle, texts, setDebouncedSearch, totalPages, setPage, page, setContainerRef, isLoading, isSearchLoading, setIsSearchLoading } = useContext(DocumentsContext)

  const containerRef = useRef(null)

  useEffect(() => {
    setContainerRef(containerRef)
  }, [containerRef])

  return (
    <section id="documents" className={classNames('dm-documents', {
      'dm-documents--is-loading': isLoading
    })} ref={containerRef}>
      <div className="dm-documents__inner dm-page-container">

        <div className="dm-documents__title-container">
          {headerTitle && ( <h2 className="dm-documents__title dm-title">{headerTitle}</h2> )}
          <div className={classNames('dm-documents__search-field', {
            'dm-show-input-loader': isSearchLoading
          })}>
            <input type="text" className="dm-input dm-input--lightgrey" placeholder={texts.searchPlaceholder} onChange={(e) => {
              setIsSearchLoading(true)
              setDebouncedSearch(e)
            }} />
          </div>
        </div>

        <div className="dm-documents__content-container">
          <Sidebar />
          <div className={classNames('dm-documents__table-container', {
            'dm-documents__table-container--full-width': categories.length === 0
          })}>
            <Table />
            <Pagination
              containerClass={'dm-documents__pagination'}
              totalPages={totalPages}
              setPage={setPage}
              activePage={page}
            />
          </div>
        </div>

      </div>
    </section>
  )
}
